import { StyleSheet, Text, View, useWindowDimensions, ScrollView } from 'react-native'
import React, { useEffect } from 'react'
import { displayFont } from '../../fonts'
import Animated, { useAnimatedStyle, useSharedValue, withDelay, withTiming, Easing } from 'react-native-reanimated';

const chapters = [
  {
    index: '01',
    title: 'Our vision',
    lines: [
      'To put iVYOOO in the world map of digital entertainment and technology as wholly owned Filipino streaming app',
      'To position iVYOOO as a globally competitive streaming app for high quality entertainment and educational content catering to local and international markets',
    ],
  },
  {
    index: '02',
    title: 'Who we are',
    lines: [
      'A wholly Filipino owned Over-the-Top (OTT) platform that is accessible anytime in the Philippines and Coming Soon on international territories.',
      'Subscription-based streaming app that features a wide selection of digital entertainment and e-learning content',
      'Distributor of internationally renowned films',
      'Provider of affordable and high-quality Video-on-Demand content such as movies, series, concerts, live events, sports and a lot more',
      'Producer of educational content that is available both online and offline nationwide.',
      'Innovator of technological features for ultimate interactive digital viewing experience',
    ],
  },
  {
    index: '03',
    title: 'Our mission',
    lines: [
      'To serve as a streaming platform that is accessible and affordable to every Filipino here and abroad.',
      'To promote and showcase high quality movies, series, concerts, live events, sports, educational programs and more for interactive entertainment and learning.',
      'To provide early exposure to e-learning among school children through watch-and-learn formatted educational content for outcome-based learning.',
      'To uplift the Philippine film makers/content creators by promoting iVYOOO as a locally developed streaming app of global standards with worldwide acceptance and patronage.',
    ],
  },
]

const motionOff = () => typeof globalThis.matchMedia === 'function' && globalThis.matchMedia('(prefers-reduced-motion: reduce)').matches

const Chapter = ({ item, narrow, delay }) => {
  const opacity = useSharedValue(motionOff() ? 1 : 0)
  useEffect(() => {
    if (motionOff()) {
      opacity.value = 1
      return
    }
    opacity.value = withDelay(delay, withTiming(1, { duration: 520, easing: Easing.out(Easing.cubic) }))
  }, [])
  const style = useAnimatedStyle(() => ({ opacity: opacity.value }))
  return (
  <Animated.View style={[styles.chapter, narrow && styles.chapterNarrow, style]}>
    <Text style={styles.index}>{item.index}</Text>
    <View style={styles.chapterBody}>
      <Text style={[styles.chapterTitle, narrow && styles.chapterTitleNarrow]}>{item.title}</Text>
      <View style={styles.rule} />
      {item.lines.map((line) => (
        <Text key={line} style={[styles.line, narrow && styles.lineNarrow]}>{line}</Text>
      ))}
    </View>
    </Animated.View>
  )
}

const AboutUS = () => {
  const window = useWindowDimensions();
  const narrow = window.width < 768;
  const heroOpacity = useSharedValue(motionOff() ? 1 : 0);

  useEffect(() => {
    if (motionOff()) return
    heroOpacity.value = withTiming(1, { duration: 500, easing: Easing.out(Easing.cubic) })
  }, [])

  const heroStyle = useAnimatedStyle(() => ({ opacity: heroOpacity.value }))

  return (
    <ScrollView style={styles.scroll} contentContainerStyle={[styles.page, narrow && styles.pageNarrow]}>
      <Animated.View style={[styles.hero, narrow && styles.heroNarrow, heroStyle]}>
        <Text style={styles.kicker}>About the studio</Text>
        <Text style={[styles.display, narrow && styles.displayNarrow]}>A Filipino picture house, streaming.</Text>
        <Text style={[styles.lead, narrow && styles.leadNarrow]}>
          iVYOOO is a wholly Filipino-owned platform for films, live events, and learning — on screen now in the Philippines, and coming soon beyond it.
        </Text>
      </Animated.View>
      {chapters.map((item, index) => (
        <Chapter key={item.index} item={item} narrow={narrow} delay={180 + index * 140} />
      ))}
    </ScrollView>
  )
}

export default AboutUS

const styles = StyleSheet.create({
  scroll: {
    flex: 1,
    width: '100%',
  },
  page: {
    paddingTop: 108,
    paddingBottom: 64,
    paddingHorizontal: 48,
    maxWidth: 980,
    width: '100%',
    alignSelf: 'center',
  },
  pageNarrow: {
    paddingTop: 92,
    paddingBottom: 40,
    paddingHorizontal: 20,
  },
  hero: {
    marginBottom: 36,
    maxWidth: 720,
  },
  heroNarrow: {
    marginBottom: 28,
  },
  kicker: {
    color: '#E61E25',
    fontFamily: displayFont,
    fontSize: 13,
    fontWeight: '700',
    letterSpacing: 2.4,
    textTransform: 'uppercase',
    marginBottom: 12,
  },
  display: {
    color: '#FFFFFF',
    fontFamily: displayFont,
    fontSize: 64,
    lineHeight: 68,
    fontWeight: '700',
    letterSpacing: -1.2,
    textWrap: 'balance',
  },
  displayNarrow: {
    fontSize: 36,
    lineHeight: 40,
    letterSpacing: -0.6,
  },
  lead: {
    marginTop: 18,
    color: '#E8E8E8',
    fontFamily: displayFont,
    fontSize: 18,
    lineHeight: 28,
    maxWidth: 640,
  },
  leadNarrow: {
    fontSize: 16,
    lineHeight: 24,
  },
  chapter: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginTop: 8,
    marginBottom: 20,
    padding: 24,
    backgroundColor: 'rgba(8, 8, 8, 0.55)',
    borderWidth: 1,
    borderColor: 'rgba(255,255,255,0.16)',
    borderRadius: 18,
    backdropFilter: 'blur(16px)',
    WebkitBackdropFilter: 'blur(16px)',
  },
  chapterNarrow: {
    flexDirection: 'column',
    padding: 18,
    marginBottom: 14,
  },
  index: {
    width: 72,
    color: '#E61E25',
    fontFamily: displayFont,
    fontSize: 22,
    fontWeight: '700',
    letterSpacing: 1,
  },
  chapterBody: {
    flex: 1,
  },
  chapterTitle: {
    color: '#FFFFFF',
    fontFamily: displayFont,
    fontSize: 28,
    lineHeight: 34,
    fontWeight: '700',
    letterSpacing: -0.3,
  },
  chapterTitleNarrow: {
    fontSize: 24,
    lineHeight: 30,
    marginTop: 8,
  },
  rule: {
    width: 42,
    height: 2,
    backgroundColor: '#E61E25',
    marginTop: 12,
    marginBottom: 14,
  },
  line: {
    color: '#F4F4F4',
    fontFamily: displayFont,
    fontSize: 16,
    lineHeight: 24,
    marginBottom: 10,
  },
  lineNarrow: {
    fontSize: 16,
    lineHeight: 24,
  },
})
